import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
// import { history, AuthRoutes, PrivateRoute, AuthProvider } from 'outlier-auth/dist/main';
// import { appAuth } from './services/auth';
import Home from './views/Home';
import Admin from './views/Admin';
import authentication from 'react-azure-b2c'
import './styles/main.scss';
import './assets/fonts/icomoon/style.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

export default class App extends React.Component {

  render() {
		console.log(authentication);
    return (
      // <AuthProvider service={appAuth}>
        <BrowserRouter basename={process.env.PUBLIC_URL}>
          <div>
            <Switch>
              <Route exact path="/admin" render={<Admin />} />
              <Route component={Home} />
            </Switch>
          </div>
        </BrowserRouter>
      // </AuthProvider>
    );
  }
}
